import { BaseModel } from "@/models/base.model"
import { type Moment } from "moment"
import { type IShallowRentalMutation } from "@/interfaces/api/shallow-mutation.interface"

export class ShallowRentalMutation extends BaseModel implements IShallowRentalMutation {
  instruction: string

  counterMutation: number

  flowDirection: number

  quantity: number

  commencementDate: Moment

  adminComment: string

  constructor(rentalMutation: IShallowRentalMutation) {
    super(rentalMutation)

    this.instruction = rentalMutation.instruction
    this.counterMutation = rentalMutation.counterMutation
    this.flowDirection = rentalMutation.flowDirection
    this.quantity = rentalMutation.quantity
    this.commencementDate = rentalMutation.commencementDate
    this.adminComment = rentalMutation.adminComment
  }
}
